module.exports = __webpack_public_path__ + "img/circle-table-6.8f3863d8.png";